import { CostDisplay } from '~/components/txn-display/cost-display/CostDisplay'
import { getFeeAmount } from '~/components/txn-display/cost-display/feeAmount'
import { useGasPaidByLabel } from '~/hooks/transactions/useGasPaidByLabel'
import { useTransactionCost } from '~/hooks/transactions/useTransactionCost'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'

export const RegularTransactionCostDisplay = ({
  transaction,
}: {
  transaction: OrgRegularTransaction | PublicRegularTransaction
}) => {
  const gasEstimates = {
    callGasLimit: transaction.callGasLimit,
    verificationGasLimit: transaction.verificationGasLimit,
    preVerificationGas: transaction.preVerificationGas,
    maxFeePerGas: transaction.maxFeePerGas,
    maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
  }

  const transactionCost = useTransactionCost({
    isMerkleTransaction: false,
    chainId: transaction.chainId,
    gasEstimates: transaction.isSponsored ? undefined : gasEstimates,
  })
  const paidBy = useGasPaidByLabel(transaction)

  return (
    <CostDisplay
      isLoading={transactionCost.isLoading}
      isSponsored={transaction.isSponsored}
      fee={getFeeAmount({
        isSponsored: transaction.isSponsored,
        sponsoredGasCost: transaction.sponsoredGasCost,
        estimateUsd: transactionCost.transactionCost,
      })}
      paidBy={paidBy}
    />
  )
}
